module.exports = __webpack_public_path__ + "static/media/mini_img1.ec3a5c66.png";